import React from 'react';
import { motion } from 'framer-motion';
import profileImage from '../../images/hero.jpg';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './About.css';

const About = () => {
  const { ref, fadeInUp, slideInLeft, slideInRight } = useScrollAnimation();
  
  return (
    <motion.section id="about" className="about-main" ref={ref} {...fadeInUp}>
      <div className="about-container">
        <motion.div 
          className="about-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="about-badge">
            <span className="about-badge-dot"></span>
            <span>Get to Know Me</span>
          </div>
          <h2 className="about-title">
            <span className="about-title-line">About</span>
            <span className="about-title-line gradient-text">Me</span>
          </h2>
        </motion.div>

        <div className="about-content">
          <motion.div 
            className="about-left"
            {...slideInLeft}
          >
            <div className="profile-image">
              <img src={profileImage} alt="Santhosh Majji" />
              <div className="image-glow"></div>
            </div>
            
            <div className="profile-info">
              <h3 className="profile-name">Santhosh Majji</h3>
              <p className="profile-role">Frontend Engineer</p>
              <div className="profile-stats">
                <div className="stat">
                  <span className="stat-number">3+</span>
                  <span className="stat-label">Years Exp</span>
                </div>
                <div className="stat">
                  <span className="stat-number">3</span>
                  <span className="stat-label">Companies</span>
                </div>
              </div>
            </div>
            
            <div className="interests-section">
              <h4 className="interests-title">What I Enjoy</h4>
              <div className="interests-tags">
                <div className="interest-tag">
                  <span className="interest-emoji">🏏</span>
                  <span>Cricket</span>
                </div>
                <div className="interest-tag">
                  <span className="interest-emoji">🎵</span>
                  <span>Music</span>
                </div>
                <div className="interest-tag">
                  <span className="interest-emoji">✈️</span>
                  <span>Travel</span>
                </div>
                <div className="interest-tag">
                  <span className="interest-emoji">💪</span>
                  <span>Fitness</span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="about-right"
            {...slideInRight}
          >
            <div className="about-text">
              <p className="about-intro">
                I'm a <span className="highlight">Frontend Engineer</span> with 3 years of experience building production-grade React.js applications across HealthTech, eCommerce, and enterprise HRMS domains.
              </p>
              
              <p className="about-description">
                Expert in <span className="highlight">TypeScript, Redux Toolkit, REST API integration, and RBAC</span> with protected routes. I specialize in performance optimization via code-splitting, lazy loading, and memoization — delivering measurable impact across every project.
              </p>
              
              <p className="about-passion">
                Skilled in responsive, mobile-first development, WCAG accessibility, and Figma-to-code workflows. Open to Remote / Hybrid opportunities and always eager to collaborate on impactful products.
              </p>
            </div>

            <div className="skills-section">
              <h4 className="skills-title">What I Do Best</h4>
              <div className="skills-tags">
                <div className="skill-tag"><span className="skill-emoji">⚛️</span><span>React.js</span></div>
                <div className="skill-tag"><span className="skill-emoji">🔷</span><span>TypeScript</span></div>
                <div className="skill-tag"><span className="skill-emoji">🗃️</span><span>Redux Toolkit</span></div>
                <div className="skill-tag"><span className="skill-emoji">⚡</span><span>Performance Opt.</span></div>
                <div className="skill-tag"><span className="skill-emoji">📱</span><span>Responsive Design</span></div>
                <div className="skill-tag"><span className="skill-emoji">🔐</span><span>RBAC & Auth</span></div>
                <div className="skill-tag"><span className="skill-emoji">🎨</span><span>Figma to Code</span></div>
                <div className="skill-tag"><span className="skill-emoji">🧪</span><span>Jest & RTL</span></div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;